import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value", "style", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"];
import { useContext } from 'react';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
import NumberTypes from '../constants/NumberTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedNumber(_ref) {
  let {
      abbreviate,
      abbreviateThreshold,
      value,
      style = NumberTypes.DECIMAL,
      simplifyCurrency = false,
      stripInsignificantZeros = true,
      useCurrencyCode
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  const NUMBER_FORMATTERS = {
    [NumberTypes.DECIMAL]: I18n.formatNumber,
    [NumberTypes.CURRENCY]: I18n.formatCurrency,
    [NumberTypes.PERCENTAGE]: I18n.formatPercentage
  };
  const numberFormatter = NUMBER_FORMATTERS[style];
  if (style === NumberTypes.CURRENCY) {
    console.warn('Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.');
  }
  if (simplifyCurrency && value % 1 === 0) {
    options.precision = 0;
  }
  if (useCurrencyCode) {
    options.unit = '';
  }
  if (stripInsignificantZeros === false) {
    // @ts-expect-error passed to untyped I18n formatters
    options.strip_insignificant_zeros = false;
  } else {
    // @ts-expect-error passed to untyped I18n formatters
    options.strip_insignificant_zeros = true;
  }
  const wrapperAttributes = {};
  if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
    wrapperAttributes.title = numberFormatter(value, options);
    // @ts-expect-error passed to untyped I18n formatters
    options.abbreviate = true;
    options.precision = 0;
  }
  const formattedNumber = numberFormatter(value, options);
  const numberToRender = useCurrencyCode ?
  // @ts-expect-error Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
  formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
  return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
    children: numberToRender
  }));
}
FormattedNumber.displayName = 'FormattedNumber';
export default FormattedNumber;